import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=7051550c&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"
import style0 from "./page8.vue?vue&type=style&index=0&id=7051550c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051550c",
  null
  
)

export default component.exports